import { WinefoPublicApi } from '../../api';
import axios from '../axios';

const winefoPublicApi = new WinefoPublicApi(undefined, undefined, axios);

export default winefoPublicApi;
